import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const gameApiSlice = createApi({
  reducerPath: 'gameApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
    prepareHeaders: (headers, { getState }) => {
      // Get the JWT token from runningGame state (player authentication)
      const token = getState().runningGame?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['GameExample', 'CatchupQuestions'],
  endpoints: (builder) => ({
    getPartnerChoices: builder.query({
      query: ({ gameRunId, gamePointCode }) => `/game/runs/${gameRunId}/partner-choices/?gamepoint_code=${gamePointCode}`,
      providesTags: (result, error, arg) => [{ type: 'GameExample', id: arg.gameRunId }],
    }),
    // Catchup endpoints for missed questions
    getMissedQuestions: builder.query({
      query: ({ groupId, memberId }) => `/game/catchup/${groupId}/${memberId}/`,
      providesTags: (result, error, arg) => [{ type: 'CatchupQuestions', id: `${arg.groupId}-${arg.memberId}` }],
    }),
    submitCatchupAnswer: builder.mutation({
      query: ({ groupId, memberId, answerId, perception, justification }) => ({
        url: `/game/catchup/${groupId}/${memberId}/`,
        method: 'POST',
        body: { answer_id: answerId, perception, justification },
      }),
      invalidatesTags: (result, error, arg) => [{ type: 'CatchupQuestions', id: `${arg.groupId}-${arg.memberId}` }],
    }),
  }),
});

export const {
    useGetPartnerChoicesQuery,
    useGetMissedQuestionsQuery,
    useSubmitCatchupAnswerMutation,
} = gameApiSlice;
